import { SET_PUNCHOUT } from 'b2b-apps/shop/punchout/testPages/redux/actionTypes';
import { PunchoutActions, PunchoutState } from './types';

const initialState: PunchoutState = {};

const reducer = (
  state: PunchoutState = initialState,
  action: PunchoutActions,
): PunchoutState => {
  switch (action.type) {
    case SET_PUNCHOUT:
      return action.payload.punchout;
    default:
      return state;
  }
};

export { reducer };
